// src/components/ui/UserAvatar.tsx

import React, { useState } from "react";
import { initials } from "../../utils/format";

// Imagen por defecto que el backend asigna a quien no sube foto: mostramos las iniciales en su lugar
const DEFAULT_IMAGES = ["default-user"];

interface Props {
  imagePath?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  size?: "sm" | "md" | "lg";
}

export default function UserAvatar({
  imagePath,
  firstName,
  lastName,
  size = "md",
}: Props) {
  const [failed, setFailed] = useState(false);
  const showImage =
    imagePath && !failed && !DEFAULT_IMAGES.some((d) => imagePath.includes(d));

  return (
    <div
      className={`avatar ${size === "sm" ? "avatar-sm" : size === "lg" ? "avatar-lg" : ""}`}
    >
      {showImage ? (
        <img src={imagePath!} alt="" onError={() => setFailed(true)} />
      ) : (
        initials(firstName, lastName)
      )}
    </div>
  );
}
